



































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  inheritAttrs: false
})
export default class ColorPicker extends Vue {
  @Prop({
    required: false,
    default: () => [
      "#0033CC",
      "#428BCA",
      "#44AD8E",
      "#A8D695",
      "#5CB85C",
      "#69D100",
      "#004E00",
      "#34495E",
      "#7F8C8D",
      "#A295D6",
      "#5843AD",
      "#8E44AD",
      "#FFECDB",
      "#AD4363",
      "#D10069",
      "#CC0033",
      "#FF0000",
      "#D9534F",
      "#D1D100",
      "#F0AD4E",
      "#AD8D43"
    ]
  })
  public colors!: string[];

  @Prop({ required: false, default: "" })
  public value!: string;

  @Prop({ required: false, default: false })
  public emitIfValid!: boolean;

  @Prop({ required: false, default: false })
  public singleLine!: boolean;

  public selectedColor: string = this.value;
  public lastValidColor: string = this.value;

  public hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/im;

  public setColor(color) {
    if (!this.emitIfValid) {
      // Emit always. Parent will handle the validation
      this.setColorIfValid(color);
      this.$emit("input", this.selectedColor);
    } else {
      // Emit only when validated
      const match = this.hexRegex.exec(color);

      if (!this.$_.isEmpty(match)) {
        this.setColorIfValid(color);
        this.$emit("input", color);
      } else {
        // Emit null to clear bound field from parent as most likely this component's client won't want invalid data
        this.$emit("input", null);
      }
    }
  }

  public setColorIfValid(color) {
    const match = this.hexRegex.exec(color);

    this.selectedColor = color;

    if (!this.$_.isEmpty(match)) {
      this.lastValidColor = color;
    }
  }
}
